import * as yup from "yup";

const schema = (message) => {
  const typeSchema = yup.object().shape({
    selectedStandardType: yup.string().min(1, message.typeRequired),
  });

  const amountSchema = yup.object().shape({
    standardAmount: yup.number().typeError(message.amountRequired).min(0),
  });

  const amountLengthSchema = yup.object().shape({
    standardAmount: yup.number().typeError(message.amountRequired).min(0).max(100),
  });

  return { typeSchema, amountSchema, amountLengthSchema };
};

export default schema;
